import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import classNames from 'classnames';
import React from 'react';
import Alert from '../Alert';
import Icon from '../Icon';
import { CLS_PREFIX } from '../../constants';
import { intentIconMap } from '../intentIconMap';

/**
 * `StatusMessage` is used for notifying users about events happened (or going to happen) in the system.
 * For showing results of performed operations [Toaster](#!/Toaster) should be used.
 * @since 1.12.0
 */
var StatusMessage = function StatusMessage(_ref) {
  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "status-message") : _ref$baseClassName,
      className = _ref.className,
      intent = _ref.intent,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "intent", "children"]);

  return React.createElement(Alert, _extends({
    className: classNames(baseClassName, ["".concat(baseClassName, "--").concat(intent)], className),
    intent: intent
  }, props), React.createElement(Icon, {
    name: intentIconMap[intent],
    className: "".concat(baseClassName, "__icon")
  }), children);
};

export default StatusMessage;